import React from "react";
import Page from "~/shared/Page";
import useNavbar from "./use-navbar";
import ControlledForm from "~/shared/form/ControlledForm";
import TextInput from "~/shared/form/TextInput";
import FormResponse from "~/shared/form/FormResponse";
import FloatingPanel from "~/shared/FloatingPanel";
import FormButton from "~/shared/form/FormButton";

export default function ContactUs() {
    return (
        <Page title="Contact Us" navBar={useNavbar()}>
            <div className="page-container">
                <FloatingPanel title="Send Us a Message" size="max-w-2xl">
                    <p>
                        Need help or have a question? Reach out via email at&nbsp;
                        <a href="mailto:info@nextgenerationfocus.org" className="red-link">info@nextgenerationfocus.org</a>,
                        or use the form below.
                    </p>
                    <ControlledForm post="contact" success="Successfully sent message." resetOnSuccess>
                        <div className="flex flex-col gap-3">
                            <TextInput label="Subject" id="subject" required />
                            <TextInput label="Message" id="message" multiline rows={7} required />
                        </div>
                        <FormResponse />
                        <FormButton family submit className="mx-auto mt-4" />
                    </ControlledForm>
                </FloatingPanel>
            </div>
        </Page>
    );
};